import localforage from "localforage";
import { ThemePreference, isThemePreference } from "@/domains/styling/theme-preference";
import { logger } from "@/modules/logger";
import { objectModule } from "@/modules/object";

const THEME_PREFERENCE_KEY = "atlas-theme-preference";

export const _readLocalStorageThemePreference = async (): Promise<ThemePreference | null> => {
  try {
    const result = await localforage.getItem<string>(THEME_PREFERENCE_KEY);
    if (isThemePreference(result)) {
      return result;
    }
    return null;
  } catch (unknownErr) {
    const err = unknownErr as Error;
    logger.warn({
      message: "[_readLocalStorageThemePreference] Failed.",
      info: {
        err: objectModule.safeErrorAsJson(err),
      },
    });
    return null;
  }
};

export const _writeLocalStorageThemePreference = async (
  preference: ThemePreference
): Promise<void> => {
  try {
    await localforage.setItem(THEME_PREFERENCE_KEY, preference);
  } catch (unknownErr) {
    const err = unknownErr as Error;
    logger.warn({
      message: "[_writeLocalStorageThemePreference] Failed.",
      info: {
        err: objectModule.safeErrorAsJson(err),
      },
    });
  }
};

export const _clearLocalStorageThemePreference = async (): Promise<void> => {
  try {
    await localforage.removeItem(THEME_PREFERENCE_KEY);
  } catch (unknownErr) {
    const err = unknownErr as Error;
    logger.warn({
      message: "[_clearLocalStorageThemePreference] Failed.",
      info: {
        err: objectModule.safeErrorAsJson(err),
      },
    });
  }
};
